import { createSlice } from '@reduxjs/toolkit';

export interface StepperType {
  currentIndex: number;
  shouldJumpToSummary: boolean;
  shouldStayOnCurrentIndex: boolean;
  isNextDisabled: boolean;
  activeUrl: string;
  initiallySelectedOptions: {
    userSupplied: boolean,
    importCaseParties: boolean,
    masterMailingMatrix: boolean,
  };
}

const initialState: StepperType = {
  currentIndex: 0,
  shouldJumpToSummary: false,
  shouldStayOnCurrentIndex: false,
  isNextDisabled: true,
  activeUrl: '/',
  initiallySelectedOptions: {
    userSupplied: false,
    importCaseParties: false,
    masterMailingMatrix: false,
  },
};

const stepperSlice = createSlice({
  name: 'stepper',
  initialState,
  reducers: {
    setNext(state) {
      state.currentIndex++;
    },
    setUrl(state, action) {
      state.activeUrl = action.payload;
    },
    setBack(state) {
      if (state.shouldStayOnCurrentIndex && state.currentIndex === 1) {
        state.currentIndex = state.currentIndex;
        state.shouldStayOnCurrentIndex = false;
        return;
      }

      state.currentIndex--;
    },
    goToStep(state, action) {
      state.currentIndex = action.payload;
      state.shouldJumpToSummary = true;
    },
    goToStepThroughNav(state, action) {
      state.currentIndex = action.payload;
    },
    stayOnStep(state) {
      state.currentIndex = state.currentIndex;
      state.shouldStayOnCurrentIndex = true;
    },
    setShouldJumpToSummary(state, action) {
      state.shouldJumpToSummary = action.payload
    },
    updateInitiallySelectedOptions(state, action: { payload: { name: keyof StepperType['initiallySelectedOptions']; value: boolean } }) {
      if (action.payload && !state.shouldJumpToSummary) {
        state.initiallySelectedOptions[action.payload.name] = action.payload.value;
      }
    },
    reset: () => initialState,
  },
});

export const { setNext, setBack, reset, goToStep, stayOnStep, setUrl, goToStepThroughNav, setShouldJumpToSummary, updateInitiallySelectedOptions } =
  stepperSlice.actions;

export default stepperSlice.reducer;
